export default "__VITE_ASSET__Bcu3yqKv__"